export default __webpack_public_path__ + "static/media/hexagon-pattern-bg.13f6161c.svg";